<template>
  <div class="supply-demand-page">
    <!-- 顶部标题栏 -->
    <div class="header">
      <h1 class="title">我的需求</h1>
      <div class="header-actions">
        <!-- <div class="icon-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div>
        <div class="icon-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
          <span class="badge"></span>
        </div> -->
      </div>
    </div>
    <!-- 列表内容 -->
    <div class="list-container">
      <div class="empty" v-if="!cardList.length">暂无数据</div>
      <div v-if="cardList.length" class="card" v-for="item in cardList" :key="item.id" @click="goDetail(item)">
        <div class="card-header">
          <div class="avatar blue">{{ item.companyName ? item.companyName.split('')[0] : ''  }}</div>
          <div class="info">
            <div class="name">{{ item.companyName || '联盟生态合作单位' }}</div>
            <div class="meta">{{ formatDate(item.createTime) }} · {{ item.addressName }}</div>
          </div>
          <span class="tag" :class="item.infoType == 1 ? 'supply' : 'demand'">{{ item.infoType == 1 ? '供应' : '需求' }}</span>
          <span class="status-tag" :class="getStatusClass(item.status)">{{ item.statusName || getStatusText(item.status) }}</span>
          <span class="listing-tag" :class="{ off: item.listingStatus === 2 }">{{ item.listingStatusName || getListingText(item.listingStatus) }}</span>
        </div>
        <div class="card-title">{{ item.title }}</div>
        <div class="card-desc">{{ item.content }}</div>
        <!-- <div class="tags">
          <span class="tag-item" :class="{ green: item.infoType == 2 }" v-for="(tag, tIndex) in item.tags" :key="tIndex">{{ tag }}</span>
        </div> -->
        <div class="card-footer">
          <div class="budget">{{ item.infoType == 2 ? '预算' : '报价' }}：<span v-if="item.budgetMin != -1" :class="item.infoType == 2 ? 'red' : 'green'">{{ item.budgetMin }}-{{ item.budgetMax }}</span><span v-if="item.budgetMin == -1" :class="item.infoType == 2 ? 'red' : 'green'">面议</span></div>
          <div class="action-group">
            <button class="action-btn edit" @click.stop="goEdit(item)">编辑</button>
            <button v-if="item.status === 2" class="action-btn shelf" @click.stop="toggleShelf(item)">{{ item.listingStatus === 2 ? '上架' : '下架' }}</button>
            <button class="action-btn delete" @click.stop="deleteItem(item)">删除</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplyDemandPage',
  data () {
    return {
      page:1,
      cardList: [],

      // 上拉加载状态
      loading: false,
      noMore: false,
      loadTimer: null 
    }
  },
  mounted () {
    this.getList()
    this.bindScroll()
  },
  beforeDestroy() {
    // 移除滚动监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
    // 清除定时器
    if (this.loadTimer) clearTimeout(this.loadTimer)

  },
  methods: {
    // 绑定滚动事件
    bindScroll(){
      window.addEventListener('scroll', this.handleScroll)
    },
    // 滚动处理函数
    handleScroll(){
      // 距离底部 100px 触发加载
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight
      if (scrollTop <= 300) {
        return // 页面还在顶部，不执行
      }
      if(scrollTop + clientHeight >= scrollHeight - 100){
        // 防抖：清除之前的定时器
        if (this.loadTimer) clearTimeout(this.loadTimer)

        // 延迟 300ms 再请求，防止疯狂触发
        if(!this.noMore){
          this.loadTimer = setTimeout(() => {
            this.getList()
          }, 300)
        }
      }
    },
    getList(){
      if (this.loading || this.noMore) return
      this.loading = true
      this.$ajax.get('/api/user/demand/page',{
        params:{
          current:this.page,
        }
      }).then((res) => {
        if(res.data.code == 200){
          this.cardList = this.cardList.concat(res.data.data.records)
          if(res.data.data.records.length<10){
            this.noMore = true
          }else{
            this.page++
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    refreshList() {
      this.page = 1
      this.noMore = false
      this.cardList = []
      this.getList()
    },
    formatDate(time) {
      if (!time) return ''
      return String(time).split('T')[0].split(' ')[0]
    },
    goDetail(item) {
      this.$router.push(`/supplyDemandInfo/${item.id}`)
    },
    goEdit(item) {
      this.$router.push({ path: '/add', query: { id: item.id } })
    },
    getStatusText(status) {
      if (status === 1) return '审核中'
      if (status === 2) return '已通过'
      if (status === 3) return '已拒绝'
      return ''
    },
    getStatusClass(status) {
      if (status === 2) return 'pass'
      if (status === 3) return 'reject'
      return 'pending'
    },
    getListingText(status) {
      if (status === 1) return '上架'
      if (status === 2) return '下架'
      return '上架'
    },
    toggleShelf(item) {
      const nextStatus = item.listingStatus === 2 ? 1 : 2
      const text = nextStatus === 1 ? '上架' : '下架'
      if (!window.confirm(`确认${text}该需求信息？`)) return
      this.$ajax.post('/api/supplyDemand/shelf', null, {
        params: { id: item.id, listingStatus: nextStatus }
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success(`${text}成功`)
          item.listingStatus = nextStatus
          item.listingStatusName = text
        } else {
          this.$toast.error(res.data.message || `${text}失败`)
        }
      }).catch(() => {
        this.$toast.error(`${text}失败，请稍后重试`)
      })
    },
    deleteItem(item) {
      if (!window.confirm('确认删除该需求信息？删除后所有人均不可见。')) return
      this.$ajax.delete('/api/supplyDemand/delete', {
        params: { id: item.id }
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('删除成功')
          this.refreshList()
        } else {
          this.$toast.error(res.data.message || '删除失败')
        }
      }).catch(() => {
        this.$toast.error('删除失败，请稍后重试')
      })
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.supply-demand-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 70px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 顶部标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.header-actions {
  display: flex;
  gap: 20px;
}

.icon-btn {
  position: relative;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  border-radius: 50%;
}

.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background: #ff4d4f;
  border-radius: 50%;
}

/* 标签栏 */
.tab-bar {
  background: #fff;
 
}
.tab-bar>div{
  display: flex;
  gap: 8px;
  width: 90%;
  margin: auto;
  background-color: #f6f7fa;
  border-radius: 8px;
  padding: 4px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 12px;
  color: #666;
}

.tab-item.active {
  background: #fff;
  color: #1a1a1a;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  gap: 10px;
  padding: 16px 20px;
  background: #fff;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 8px;
  font-size: 10px;
  color: #666;
}
/* 下拉弹窗 */
.drop-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.drop-box {
  width: 80%;
  max-height: 400px;
  background: #fff;
  border-radius: 12px;
  overflow: auto;
}
.drop-item {
  padding: 14px 20px;
  font-size: 12px;
  color: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drop-item:active {
  background: #f5f7fa;
}
.check {
  color: #165DFF;
  font-weight: bold;
}

/* 列表容器 */
.list-container {
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 卡片样式 */
.card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  margin-right: 12px;
}

.avatar.blue {
  background: linear-gradient(135deg, #4080ff, #5e5ce6);
}

.avatar.green {
  background: #0fb864;
}

.avatar.orange {
  background: linear-gradient(135deg, #ff4d4f, #ff7a45);
}

.avatar.purple {
  background: linear-gradient(135deg, #9254de, #722ed1);
}

.info {
  flex: 1;
}

.name {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.meta {
  font-size: 11px;
  color: #999;
}

.tag {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.tag.demand {
  background: #fff7e6;
  color: #faad14;
}

.tag.supply {
  background: #e6ffed;
  color: #36c66d;
}

.status-tag {
  margin-left: 6px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  white-space: nowrap;
}

.status-tag.pending {
  background: #fff7e6;
  color: #fa8c16;
}

.status-tag.pass {
  background: #e6ffed;
  color: #36c66d;
}

.status-tag.reject {
  background: #fff1f0;
  color: #f53f3f;
}

.listing-tag {
  margin-left: 6px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #e6f7ff;
  color: #1677ff;
  font-size: 11px;
  white-space: nowrap;
}

.listing-tag.off {
  background: #f0f2f5;
  color: #8c8c8c;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.card-desc {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 16px;
}

.tags {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.tag-item {
  padding: 6px 12px;
  background: #e8f3ff;
  color: #165DFF;
  border-radius: 6px;
  font-size: 13px;
}

.tag-item.green {
  background: #e6ffed;
  color: #36c66d;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.budget {
  font-size: 13px;
  color: #666;
}

.red {
  color: #ff4d4f;
  font-weight: 600;
}

.green {
  color: #0fb864;
  font-weight: 600;
}

.action-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  max-width: 150px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.action-btn.edit {
  background: #165DFF;
  color: #fff;
}

.action-btn.shelf {
  background: #fff7e6;
  color: #fa8c16;
}

.action-btn.delete {
  background: #fff1f0;
  color: #f53f3f;
}

/* 悬浮按钮 */
.fab-btn {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: #165DFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
.empty{
  width: 100%;
  height: 300px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0,0,0,0.3)
}
</style>



// WEBPACK FOOTER //
// src/components/menu/user/demand.vue